module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre9 sgc-14 sgc-51 sigil_not_in_toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1 dot1000"
  }), _vm._v(" "), _c('p', {
    staticClass: "sgc-82"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ListofIllustrations"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ListofMaps"
    }
  }, [_vm._v("LIST OF MAPS")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Foreword"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("INTRODUCTION TO AMERICAN MILITARY ORGANIZATION")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Part01"
    }
  }, [_vm._v("Part I. THE BEGINNINGS: 1918–38")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter01"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("1.")]), _vm._v(" Join the Tank Corps!")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter02"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("2.")]), _vm._v(" Into the Breach: The Hindenburg Line Attack")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("3.")]), _vm._v(" Lean Times: The Inter-War Years")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II. WAR CLOUDS: 1939–41")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("4.")]), _vm._v(" The Rebirth of American Armor")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("5.")]), _vm._v(" Patton’s Blitzkrieg: The Tennessee Maneuvers")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("6.")]), _vm._v(" Swamps and Snakes: The Louisiana Maneuvers")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("7.")]), _vm._v(" Dress Rehearsal: The Carolina Maneuvers")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III. THE MEDITERRANEAN THEATER: 1942–43")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("8.")]), _vm._v(" Tanks at Sea: The Final Preparations: 1942")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt13"
  }, [_vm._v("9.")]), _vm._v(" Operation Torch: The Invasion of North Africa")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt12"
  }, [_vm._v("10.")]), _vm._v(" Operation Husky: Sicily")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-81"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV. OMAHA BEACH TO BERLIN: 1944–45")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt12"
  }, [_vm._v("11.")]), _vm._v(" Close Combat in the Hedgerows: Normandy")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt12"
  }, [_vm._v("12.")]), _vm._v(" Breakout and Pursuit: August 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt12"
  }, [_vm._v("13.")]), _vm._v(" The Siege of Aachen")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt12"
  }, [_vm._v("14.")]), _vm._v(" Collapsing the Bulge: The Ardennes")])]), _vm._v(" "), _c('p', {
    staticClass: "sgc-19 indent2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "flt12"
  }, [_vm._v("15.")]), _vm._v(" The Race for Berlin")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262d6358","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Toc.vue
// module id = 72
// module chunks = 0